import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/quick/apps/pwa/app/[lang]/(form)/DemandLayout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginModal"] */ "/quick/apps/pwa/app/[lang]/(form)/DemandLayout/LoginModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/quick/apps/pwa/app/[lang]/(form)/DemandLayout/Menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Fabs"] */ "/quick/apps/pwa/components/core/Fab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NoSSR"] */ "/quick/apps/pwa/components/core/NoSSR.tsx");
